import { renderReact } from "hypernova-react";
import BurgerMenu from "web/react/components/burger-menu/burger-menu";
import CookieBannerVariation from "web/react/components/cookie-banner/cookie-banner-variation";
import EmailCaptureOverlay from "web/react/components/email-capture-overlay/email-capture-overlay";
import Example from "web/react/components/example/example";
import ExpressCheckoutProductPage from "web/react/components/express-checkout-product-page/express-checkout-product-page";
import FBProductLandingOverlay from "web/react/components/fb-product-landing-overlay/fb-product-landing-overlay";
import FeedsShowMoreContainer from "web/react/components/feeds-show-more-container/feeds-show-more-container";
import FeedsSeoContent from "web/react/components/feeds-seo-content/feeds-seo-content";
import FilterContainer from "web/react/components/filter-container/filter-container";
import FollowStickyBanner from "web/react/components/follow-sticky-banner/follow-sticky-banner";
import HomepageOverlay from "web/react/components/homepage-overlay/homepage-overlay";
import ProductArea from "web/react/components/product-area/product-area";
import RecentlyViewedEmailCapture from "web/react/components/recently-viewed-email-capture/recently-viewed-email-capture";
import RelatedProductsRails from "web/react/components/related-products-rails/related-products-rails";
import RelatedSearchesRail from "web/react/components/related-searches-rail/related-searches-rail";
import RetailerPromotionHub from "web/react/components/retailer-promotion-hub/retailer-promotion-hub";
import SearchButton from "web/react/components/search-button/search-button";
import ProductPage from "web/react/pages/product/in-stock/in-stock";
import OOSProductPage from "web/react/pages/product/out-of-stock/out-of-stock";
import withRedux from "web/react/redux-provider";

export const renderableComponents: { [name: string]: React.ComponentType<any> } = {
    BurgerMenu,
    CookieBannerVariation,
    EmailCaptureOverlay,
    Example,
    ExpressCheckoutProductPage,
    FBProductLandingOverlay,
    FeedsSeoContent,
    FeedsShowMoreContainer: withRedux(FeedsShowMoreContainer),
    FilterContainer: withRedux(FilterContainer),
    FollowStickyBanner,
    HomepageOverlay,
    OOSProductPage,
    ProductArea: withRedux(ProductArea as any), // TODO: ProductArea's proptypes are broken
    ProductPage,
    RecentlyViewedEmailCapture,
    RelatedProductsRails,
    RelatedSearchesRail,
    RetailerPromotionHub,
    SearchButton,
};

export function initialiseReact(): void {
    for (let [name, component] of Object.entries(renderableComponents)) {
        renderReact(name, component);
    }
}
